import { variationType } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/helpers/types';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';

export const getStartYear = (startDate: SimulationDateString): number =>
    new Date(startDate).getFullYear();

export const displayTypeSelector = (
    startDate: SimulationDateString,
    year: number,
) => {
    const startYear = getStartYear(startDate);
    return year > startYear ? 'budgetProposalItem' : 'projectionItem';
};
export const previsionnalVariationSelector = (
    startDate: SimulationDateString,
    year: number,
): variationType => {
    const item = displayTypeSelector(startDate, year);
    const currentYear = new Date().getFullYear();
    const startYear = getStartYear(startDate);

    if (item === 'budgetProposalItem' && currentYear === startYear + 1) {
        return variationType.PAST_LAST_YEAR;
    }
    if (currentYear <= year) {
        return variationType.PREVISIONNAL;
    }
    return variationType.PAST_PREVISIONNAL;
};
export const formatPercentageNumber = (value: number): string => {
    const symbol = value > 0 ? '+' : '';
    return `${symbol}${value.toFixed(2).replace('.', ',')} %`;
};
